import React, { useState } from 'react';

import { Box, Typography, Link } from '@mui/material';
import CustomKebabMenu from 'components/CustomKebabMenu';
import HistoryBackArrow from 'components/HistoryBackArrow';
import PropTypes from 'prop-types';

import styles from './integrationHeader.module.css';

import { ReactComponent as BackIcon } from 'asset/IconsPack/at_arrow-narrow-left-filled.svg';
import { ReactComponent as ListIcon } from 'asset/IconsPack/at_list-filled.svg';
import { ReactComponent as ShareIcon } from 'asset/IconsPack/at_share-04.svg';
import { ReactComponent as ZapIcon } from 'asset/IconsPack/at_zap.svg';

import { HEADER_MENU_LABELS } from '../../constants';
import ManageBookingChannels from '../ManageBookingChannels';

function IntegrationHeader({ title, link, isActive = false, integrationId, onManageListings }) {
    const [openBookingChannels, setOpenBookingChannels] = useState(false);

    const menuOptions = [
        {
            id: 'bookingChannels',
            name: HEADER_MENU_LABELS.MANAGE_BOOKING_CHANNELS,
            icon: ZapIcon,
            onClick: () => setOpenBookingChannels(true),
            divider: true,
        },
        {
            id: 'listings',
            name: HEADER_MENU_LABELS.MANAGE_LISTINGS,
            icon: ListIcon,
            onClick: onManageListings,
            divider: true,
        },
        {
            id: 'setupGuide',
            name: HEADER_MENU_LABELS.SETUP_GUIDE,
            icon: ShareIcon,
            href: link,
        },
    ];

    return (
        <Box className={styles.integrationHeader}>
            <Box className={styles.titleBox}>
                <HistoryBackArrow icon={<BackIcon className={styles.backIcon} />} />
                <Typography className={styles.integrationHeading}>{title}</Typography>
            </Box>
            {/* If integration is active more options along with setup guide need to shown, for inactive integration only setup guide option is there */}
            {isActive ? (
                <CustomKebabMenu
                    menuId="integration-header-menu"
                    items={menuOptions}
                    buttonClassName={styles.menuButton}
                    moreIconClass={styles.menuButtonIcon}
                    menuClassName={styles.menuPaper}
                />
            ) : (
                <Link
                    href={link}
                    target="_blank"
                    rel="noreferrer"
                    className={styles.integrationGuideLink}
                >
                    Setup Guide <ShareIcon className={styles.shareIcon} />
                </Link>
            )}
            {isActive && (
                <ManageBookingChannels
                    open={openBookingChannels}
                    onClose={() => setOpenBookingChannels(false)}
                    integrationId={integrationId}
                />
            )}
        </Box>
    );
}

IntegrationHeader.propTypes = {
    title: PropTypes.string,
    link: PropTypes.string,
    isActive: PropTypes.bool,
    integrationId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    onManageListings: PropTypes.func,
};

export default IntegrationHeader;
